import { Session } from '@uplift/types';
import { getAppointmentById, getUser, Appointment, User, getUserProfile, UserProfile } from '@uplift/api';

export const fetchAppointmentForClinicalNotes = async (appointmentId: string) => {
  try {
    const appointment = await getAppointmentById(appointmentId);
    const [ patient, patientProfile, provider ] = await Promise.all([
      getUser(appointment.data.patientId),
      getUserProfile(appointment.data.patientId),
      getUser(appointment.data.providerId),
    ]);

    return transformAppointment({
      appointment: appointment.data,
      patient: patient.data,
      provider: provider.data,
      patientProfile: patientProfile.data,
    });
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

type TransformAppointmentArgsType = {
  appointment: Appointment;
  patient: User;
  provider: User;
  patientProfile: UserProfile;
};

const transformAppointment = ({ appointment, patient, provider, patientProfile }: TransformAppointmentArgsType): Session => {
  return {
    createdAt: appointment.createdAt,
    fromDatetime: appointment.fromDatetime,
    toDatetime: appointment.toDatetime,
    state: appointment.state,
    id: appointment.id,
    appointmentType: appointment.type,
    patient: {
      id: patient.id,
      firstName: patient.firstName,
      lastName: patient.lastName,
      subsystem: patient.subsystem,
      userProfile: {
        preferredName: patientProfile.preferredName
      }
    },
    provider: {
      id: provider.id,
      firstName: provider.firstName,
      lastName: provider.lastName
    },
  } satisfies Session;
};
